import { lessonSectionAdapter } from '@/Module/Lesson/Store/Adapter';
import type { IState } from '@/Module/Store/Model';
import { teacherAdapter } from '@/Module/Teacher/Store/Adapter';
import { categoryTeacherListAdapter } from '@/Module/Teacher/Store/Adapter/categoryTeacherListAdapter';

export const { selectById: teacherSelectById } = teacherAdapter.getSelectors<IState>(state => state.teacher);

export const { selectById: lessonSelectByTeacherId, selectIds: lessonSelectByTeacherIds } =
  lessonSectionAdapter.getSelectors<IState>(state => state.lessonTeacher);

export const { selectById: categoryTeacherListSelectByCategoryId } = categoryTeacherListAdapter.getSelectors<IState>(
  state => state.teacherCategory,
);
